import axiosInstance from './axiosService';

class ApplicationService {
  // Generate a GUID from backend
  async generateGuid() {
    try {
      const response = await axiosInstance.get('/generate-guid');
      return response.data;
    } catch (error) {
      console.error('Error generating GUID:', error);
      throw error;
    }
  }

  // Save individual form step to backend
  async saveFormStep(stepNumber, data) {
    try {
      const response = await axiosInstance.post(`/save-form/${stepNumber}`, data);
      return response.data;
    } catch (error) {
      console.error("Error saving form step:", error);
      throw error;
    }
  }
  

  // Submit final form
  async submitFinalForm(data) {
    try {
      const response = await axiosInstance.post('/submit-form', data);
      return response.data;
    } catch (error) {
      console.error('Error submitting final form:', error);
      throw error;
    }
  }

  // Retrieve application form by ID
  async getForm(id) {
    try {
      const response = await axiosInstance.get(`/resume-from/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching application data:', error);
      throw error;
    }
  }

  async saveAppReview({ guid, rating }) {
    try {
      const response = await axiosInstance.post('/save-review', { guid, rating });
      return response.data;
    } catch (error) {
      console.error('Error saving review:', error.response?.data || error.message);
      throw error;
    }
  }
  
}

const applicationService = new ApplicationService();
export default applicationService;
